export default "__VITE_ASSET__KjjHqVt$__"